import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Search, FileBarChart, Bookmark } from 'lucide-react'

const actions = [
  {
    title: 'Search Accounts',
    description: 'Discover Instagram accounts based on your criteria',
    icon: Search,
    href: '/search',
    tooltip: 'Find accounts matching your specific requirements',
    colors: {
      icon: 'text-blue-600 dark:text-blue-400',
      bg: 'bg-blue-50/50 dark:bg-blue-950/20',
      border: 'border-blue-200/30 dark:border-blue-800/30'
    }
  },
  {
    title: 'Instagram Analytics', 
    description: 'Analyze Instagram profiles and track performance',
    icon: FileBarChart,
    href: '/request-analytics',
    tooltip: 'Get detailed analytics for Instagram accounts',
    colors: {
      icon: 'text-green-600 dark:text-green-400',
      bg: 'bg-green-50/50 dark:bg-green-950/20',
      border: 'border-green-200/30 dark:border-green-800/30'
    }
  },
  {
    title: 'Create Watchlist',
    description: 'Build a list of instagram accounts to track',
    icon: Bookmark,
    href: '/watchlists/create',
    tooltip: 'Group accounts into organized watchlists',
    colors: {
      icon: 'text-purple-600 dark:text-purple-400',
      bg: 'bg-purple-50/50 dark:bg-purple-950/20',
      border: 'border-purple-200/30 dark:border-purple-800/30'
    }
  }
]

// Removed fade-up variants to keep interactions snappy while preserving hover effects

export function QuickActions() {
  return (
    <TooltipProvider>
      <div className="space-y-4">
        <h2 className="text-lg font-semibold tracking-tight">
          Quick Actions
        </h2>
        
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {actions.map((action) => (
            <motion.div
              key={action.title}
              whileHover={{ y: -2 }}
              transition={{ duration: 0.2 }}
            >
              <Card className={`group hover:shadow-md transition-all duration-200 border ${action.colors.border}`}>
                <CardHeader className="pb-3">
                  <div className="flex items-start gap-3">
                    <div className={`p-2 rounded-lg ${action.colors.bg} flex-shrink-0`}>
                      <action.icon className={`h-4 w-4 ${action.colors.icon}`} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <CardTitle className="text-base font-semibold group-hover:text-primary transition-colors">
                        {action.title}
                      </CardTitle>
                      <CardDescription className="text-sm mt-1">
                        {action.description}
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="pt-0">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button asChild size="sm" variant="outline" className="w-full">
                        <Link to={action.href}>
                          Get Started
                        </Link>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>{action.tooltip}</p>
                    </TooltipContent>
                  </Tooltip>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </TooltipProvider>
  )
} 